export const NOTIFICATIONS_QUERY_KEY = ["system", "notifications"];
